import {
  validatePhone,
  validateEmail,
  validateDocument,
  validateCuilCuit,
  validateZipCode,
  validateIsRequired,
  validateInputText,
  validateBusinessName
} from '../common/ClienteFieldValidator.utils'
import {
  ARGENTINA_PHONE_CODE,
  composePhone,
  isArgentinaPhoneCode
} from '../common/phone/phoneUtils'

//Se obtiene el id de Argentina para NO validar provincia ni localidad en caso de que NO se selecciona Argentina
const ID_ARGENTINA = "be64bdb9-9afb-11ea-a665-0242ac120004"

export const clientType = {
    HUMANA: 'HUMANA',
    JURIDICA: 'JURIDICA'
}

export const clientBusinessType = {
  PARTICULAR: 'PARTICULAR',
  REVENTA: 'REVENTA',
  AGENTE_OFICIAL: 'AGENTE_OFICIAL',
  FLOTA: 'FLOTA',
  EMPLEADO: 'EMPLEADO',
}

export const DEFAULT_CLIENT_BUSINESS_TYPE = clientBusinessType.PARTICULAR

export const clientBusinessTypeOptions = [
  { id: clientBusinessType.PARTICULAR, name: 'Particular' },
  { id: clientBusinessType.REVENTA, name: 'Reventa' },
  { id: clientBusinessType.AGENTE_OFICIAL, name: 'Agente oficial' },
  { id: clientBusinessType.FLOTA, name: 'Flota' },
  { id: clientBusinessType.EMPLEADO, name: 'Empleado' },
]

export const defaultClient = Object.freeze({
    doctype: 'DNI',
    document: '',
    client_type: clientType.HUMANA,
    client_business_type: DEFAULT_CLIENT_BUSINESS_TYPE,
    marital_status: 'SOLTERO',
    phoneCountryCode: ARGENTINA_PHONE_CODE,
    confirmed: false,
    Client_profile: {
      first_car: true,
      dependency_relationship: true
    }
})

export const DEFAULT_FIELDS = {
  client_type: 'HUMANA',
  client_business_type: DEFAULT_CLIENT_BUSINESS_TYPE,
  address: null,
  business_name: null,
  city: null,
  country: null,
  cuil_cuit: null,
  email: null,
  firstname: null,
  information: null,
  lastname: null,
  marital_status: null,
  nationality: null,
  ownership_type: null,
  phone: null,
  province: null,
  zip_code: null,
  tax_condition: null,
  Client_profile: {
    first_car: true,
    dependency_relationship: true
  },
}

export const DEFAULT_FIELDS_NOT_REQUIRED = {
  cuil_cuit: {
    client_type: "HUMANA",
    noValidate: true
  },
  zip_code: {
    noValidate: true
  },
  address: {
    noValidate: true
  },
  province: {
    noValidate: true
  },
  city: {
    noValidate: true
  },
  country: {
    noValidate: true
  },
  tax_condition: {
    noValidate: true
  },
}

// phoneCountryCode es un campo solo del formulario y no se envia al backend
export const withComposedPhone = cliente => {
  const { phoneCountryCode, ...clienteToSave } = cliente || {}
  return {
    ...clienteToSave,
    phone: composePhone(phoneCountryCode, cliente?.phone)
  }
}

export const validateForm = (field, noRequired) => {
  const formErrors = {}

  formErrors.phone = validatePhone(field.phone, {
    skipMaxLength: true,
    skipMinLength: !isArgentinaPhoneCode(field.phoneCountryCode)
  })
  formErrors.email = validateEmail(field.email)
  formErrors.document = validateDocument(field.document)
  formErrors.zip_code = validateZipCode(field.zip_code, noRequired?.zip_code)
  formErrors.address = validateIsRequired(field.address, noRequired?.address)
  //Acá se pregunta si el country es Argentina, si lo es valida y sino no 
  formErrors.province = field.country === ID_ARGENTINA && validateIsRequired(field.province, noRequired?.province)
  formErrors.city = field.country === ID_ARGENTINA && validateIsRequired(field.city, noRequired?.city)
  formErrors.country = validateIsRequired(field.country, noRequired?.country)
  formErrors.firstname = validateInputText(field.firstname)
  formErrors.lastname = validateInputText(field.lastname)
  formErrors.business_name = validateBusinessName(field.business_name)
  formErrors.cuil_cuit = validateCuilCuit(field.cuil_cuit, noRequired?.cuil_cuit?.client_type, field.client_type)
  formErrors.tax_condition = validateIsRequired(field.tax_condition, noRequired?.tax_condition)

  let personalTab, aditionalTab

  if (field.client_type === 'HUMANA') {
    personalTab =
      !formErrors.lastname?.error &&
      !formErrors.firstname?.error &&
      !formErrors.phone?.error &&
      !formErrors.email?.error &&
      !formErrors.phone?.error &&
      !formErrors.cuil_cuit?.error
  } else {
    personalTab =
      !formErrors.lastname?.error &&
      !formErrors.firstname?.error &&
      !formErrors.phone?.error &&
      !formErrors.email?.error &&
      !formErrors.phone?.error &&
      !formErrors.cuil_cuit?.error &&
      !formErrors.business_name?.error
  }

  aditionalTab =
    !formErrors.city?.error &&
    !formErrors.province?.error &&
    !formErrors.address?.error &&
    !formErrors.zip_code?.error &&
    !formErrors.country?.error &&
    !formErrors.tax_condition?.error

  return { formErrors, personalTab, aditionalTab }

}

export const GLOBAL_ERROR_MESSAGE = 'Los campos y solapas en rojo son obligatorios.'

export const PAGINATIONS_CONSTANTS ={
  PAGE:'page',
  PER_PAGE:'per_page',
  KEYWORD:'keyword'
}